import { render } from "./humanityCourseDetail.vue?vue&type=template&id=6e0c45b6&scoped=true"
import script from "./humanityCourseDetail.vue?vue&type=script&lang=js"
export * from "./humanityCourseDetail.vue?vue&type=script&lang=js"

import "./humanityCourseDetail.vue?vue&type=style&index=0&id=6e0c45b6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0c45b6"]])

export default __exports__